/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';

import { EntityTypesDownloadContainer } from 'containers/DownloadContainers';
import { DetailsSummaryContainer } from 'containers/DetailsSummaryContainer';
import RelatedEntitiesContainer from 'containers/RelatedEntitiesContainer';

import { setModal } from 'ducks/modal';

import DeleteEntity from 'components/DeleteEntity';
import Section from 'components/UIKit/Details/Content/Section';
import { Spinner } from 'components/UIKit/Spinner';
import DangerButton from 'components/UIKit/Button/DangerButton';
import { Row } from 'components/UIKit/Flex';
import { TrashIcon } from 'components/icons';

import DetailsPanel from '../DetailsPanel';
import CaseDetailsNavigation from './CaseDetailsNavigation';
import TransactionList from '../TransactionList';
import AnnotationsList from '../AnnotationsList';

function CaseDetails({
  children, style, relatedEntities, defs, dispatch, beingDeleted,
}: Object): React.Element {
  let cas = children.item;
  let headerId = ((children || {}).item || {}).submitter_id;

  let relatedEntitesKeys = Object.keys(relatedEntities.relatedEntities);

  let hasClinical =
    relatedEntitesKeys.length &&
    (relatedEntities.relatedEntities.demographic > 0 ||
    relatedEntities.relatedEntities.diagnosis > 0);

  let processing = beingDeleted.find(x => x.ids.includes(cas.id));

  return (
    <DetailsPanel
      style={style}
      headerId={headerId}
      details={children}
      defs={defs}
      NavigationComponent={CaseDetailsNavigation}
    >
      <Section id="actions" header="actions">
        <Row style={{ flexWrap: 'wrap' }}>
          <EntityTypesDownloadContainer
            customDataTestID="button-clinical"
            entityTypes={['case']}
            options={{
              withChildren: true,
              category: 'clinical'
            }}
            disabled={!hasClinical}
          >
            Clinical
          </EntityTypesDownloadContainer>
          <DangerButton
            customDataTestID="button-delete"
            PrefixComponent={
              processing
                ? <Spinner style={{ width: '15px', height: '15px', marginRight: '0.5rem' }} />
                : <TrashIcon style={{ marginRight: '0.2rem' }} />
            }
            disabled={cas.state === 'submitted' || processing}
            onClick={() => dispatch(setModal({
              Component: () => <DeleteEntity entity={cas} />,
            }))}
          >
            {processing ? `Processing..` : 'Delete'}
          </DangerButton>
        </Row>
      </Section>
      <Section customDataTestID="table-details" id="details">
        <DetailsSummaryContainer
          entity={cas}
          entityType="case"
        />
      </Section>
      <Section customDataTestID="table-related-entities" id="related entities" header="related entities">
        { relatedEntities.isFetching ? <Spinner /> :
        <RelatedEntitiesContainer entityId={cas.id} entityType="case" />
        }
      </Section>

      <Section customDataTestID="table-annotations" id="annotations" header="annotations">
      { (cas.annotations || []).length ? (
        <AnnotationsList>{cas.annotations}</AnnotationsList>
      ) : 'No Annotations submitted'}
      </Section>

      <Section customDataTestID="table-transactions" id="transactions" header="transactions">
       { (cas._transaction_logs || []).length ? (
          <TransactionList>{cas._transaction_logs}</TransactionList>
       ) : 'No transactions'}
      </Section>
    </DetailsPanel>
  );
}

export default connect(
  state => ({
    relatedEntities: state.relatedEntities,
    defs: state.entityDefinitions,
    beingDeleted: state.details.beingDeleted,
  })
)(CaseDetails);
